import { esignceremonystatusOptions, esignwitnessstatusOptions } from "Models/Enums";
import moment from "moment";
import React, {  } from "react";
import {  Container, Divider, Grid, Header, Icon } from "semantic-ui-react";
import { ESignSignee } from "../ESignEnevlopeList";

type Props = {
	signee: ESignSignee;
	requireWitness: boolean;
};

export const SigneeDetails: React.FunctionComponent<Props> = ({ signee, requireWitness }) => {
	const renderValue = (value: string | undefined) => {
		if(!value) {
			return 'N/A';
		}

		if (value.length <= 0) {
			return 'N/A';
		}

		return value;
	}
	return (
		<Grid columns={2} divided className="signee-detail">
			<Grid.Row>
				<Grid.Column>
					<Header as="h4">
						<Icon name="user" /> Signatory: {signee.userName}
					</Header>
				</Grid.Column>
			</Grid.Row>
			<Divider />
			<Grid.Row>
				<Grid.Column>
					<Container>
						<Icon name="user" /> Signee: {signee.userName} (<b>{esignceremonystatusOptions[signee.status]}</b>)
					</Container>
				</Grid.Column>
				<Grid.Column>
					<Container>
						<Icon name="mail" /> Email: {signee.userEmail.toLocaleLowerCase()}
					</Container>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column>
					<Container>
						<Icon name="phone" /> Phone: {renderValue(signee.userPhone)}
					</Container>
				</Grid.Column>
				<Grid.Column>
					<Container>
						<Icon name="map marker alternate" /> IP Address: {renderValue(signee.ipAddress)}
					</Container>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column>
					<Container>
						<Icon name="clock outline" /> Completion Time: {signee.signatureTimeStamp ? moment(signee.signatureTimeStamp).format('MM/DD/YYYY - hh:mm A') : 'N/A'}
					</Container>
				</Grid.Column>
			</Grid.Row>
			{signee.witness && requireWitness && (
				<>
					<Divider />
					<Grid.Row>
						<Grid.Column>
							<Header as="h4">
								<Icon name="user secret" /> Witness Detail provided by {signee.userName}
							</Header>
						</Grid.Column>
					</Grid.Row>
					<Divider />
					<Grid.Row>
						<Grid.Column>
							<Container>
								<Icon name="user" /> Witness: {signee.witness.userName} (<b>{esignwitnessstatusOptions[signee.witness.status]}</b>)
							</Container>
						</Grid.Column>
						<Grid.Column>
							<Container>
								<Icon name="mail" /> Email: {signee.witness.userEmail.toLocaleLowerCase()}
							</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<Container>
								<Icon name="phone" /> Phone: {renderValue(signee.witness.userPhone)}
							</Container>
						</Grid.Column>
						<Grid.Column>
							<Container>
								<Icon name="map marker alternate" /> IP Address: {renderValue(signee.witness.ipAddress)}
							</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<Container>
								<Icon name="clock outline" /> Completion Time: {signee.witness.signatureTimeStamp ? moment(signee.witness.signatureTimeStamp).format('MM/DD/YYYY - hh:mm A') : 'N/A'}
							</Container>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
		</Grid>
	)
};